export default __webpack_public_path__ + "static/media/footerlogotipo.6028b41a.svg";